import React from 'react';
import * as S from './styles';

const Footer: React.FC = () => {
  return (
    <S.Container
      className="wow animate__animated animate__fadeIn"
      data-wow-duration="1s"
    >
      <S.Header>Créditos</S.Header>
      <S.Wrapper>
        <S.Column>
          <div>
            <span>Beleza:</span>
            <h6>Guilherme Casagrande</h6>
          </div>
          <div>
            <span>Produção de moda:</span>
            <h6>Letícia Alahmar</h6>
          </div>
          <div>
            <span>Assistente de produção de moda:</span>
            <h6>Vinicius Matos e Maju Bergamaschi</h6>
          </div>
        </S.Column>
        <S.Column>
          <div>
            <span>Produção de arte e cenografia:</span>
            <h6>Anderson Rodriguez</h6>
          </div>
          <div>
            <span>Assistentes de foto:</span>
            <h6>Flávio Lucas e Fernando Bentes</h6>
          </div>
          <div>
            <span>Assistentes de beleza:</span>
            <h6>Danielle Quessada e Juliana Bomfim</h6>
          </div>
        </S.Column>
        <S.Column>
          <div>
            <span>Manicure:</span>
            <h6>Thayna Dandara</h6>
          </div>
          <div>
            <span>Produção executiva:</span>
            <h6>Isabela de Paula</h6>
          </div>
          <div>
            <span>Tratamento de imagem:</span>
            <h6>Bruno Rezende</h6>
          </div>
        </S.Column>
        <S.Column>
          <div>
            <span>Assistente de vídeo:</span>
            <h6>Isabella Barreto</h6>
          </div>
          <div>
            <span>Som direto:</span>
            <h6>Rodrigo Paciência</h6>
          </div>
          <div>
            <span>Camareira:</span>
            <h6>Egle Doxum</h6>
          </div>
        </S.Column>
      </S.Wrapper>
    </S.Container>
  );
};

export default Footer;
